import { baseEntitySchema } from '../entity.js'
import { z } from 'zod'
import { coreElementValueSchema } from '../slate/slate-element.js'

export const noteSchema = baseEntitySchema.extend({
  type: z.literal('note'),
  noteType: z.enum(['general', 'performance', 'instrument']).optional(),
  /** Notes use YDoc for collaborative editing. Children is kept for backwards compatibility. */
  children: coreElementValueSchema.nullable().optional(),
})

export function isNote(node: unknown): node is z.infer<typeof noteSchema> {
  return noteSchema.safeParse(node).success
}

export type Note = z.infer<typeof noteSchema>

export default noteSchema
